module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Home/Flower#1-b8d72b886630b1444836b0e601154ca4.svg";